import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationComponent } from './registration.component';
const routes: Routes = [
  {
    path: '',
    component: RegistrationComponent
  },

  { path: 'registration', component: RegistrationComponent }
];


export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
